import apiClient from './api';
import { API_ENDPOINTS } from '@/config/api.config';

class FileService {
  async uploadFile(file: File) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await apiClient.put(API_ENDPOINTS.STORAGE.UPLOAD, formData);
      return response.data.data;
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  }
}

export const fileService = new FileService();
